var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"total-average"},[(_vm.hasSubmission)?_c('div',{staticClass:"average"},[_c('span',{staticClass:"label"},[_vm._v(_vm._s(_vm.$t('score')))]),_c('span',{staticClass:"score"},[_vm._v(_vm._s(_vm.$formatValue(_vm.trialFeedback.average)))]),_c('span',{staticClass:"total"},[_vm._v("/5")])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }